<template>
  <section
    class="user-comment-list--container"
    :style="{
      maxHeight: maxListHeight > 0 ? `${maxListHeight}px` : 'auto',
    }"
  >
    <div v-if="combinedCommentAndStatusList.length" class="user-comments">
      <ul class="user-comment-list--list">
        <transition-group name="comment" tag="div" appear>
          <li
            v-for="comment in combinedCommentAndStatusList"
            :key="`${comment.id}${comment.updatedOn}`"
            class="user-comment-list--item"
          >
            <asc-user-comment-status
              v-if="comment.ucType === 'statusUpdate'"
              :status-update="comment"
              :is-expanded="isExpanded"
            >
            </asc-user-comment-status>
            <asc-user-comment
              v-if="comment.ucType === 'userComment'"
              :user-comment="comment"
              :user-list="userList"
              :is-user="comment.userId === user.userId"
              :disabled="disabled"
              :is-expanded="isExpanded"
              :comment-change-event-on-blur="commentChangeEventOnBlur"
              @delete="handleDelete"
              @post="handlePost"
            />
            <div class="user-comment-list--border"></div>
          </li>
        </transition-group>
      </ul>
    </div>
    <p v-else class="noData">{{ labelText }}</p>
  </section>
</template>

<script>
import AscUserComment from './AscUserComment'
import AscUserCommentStatus from './AscUserCommentStatus'
import { AscUserCommentPropsMixin } from '@/components/mixins'

export default {
  name: 'AscUserCommentList',

  components: {
    AscUserComment,
    AscUserCommentStatus,
  },

  mixins: [AscUserCommentPropsMixin],

  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
    maxListHeight: {
      type: Number,
      default: 0,
    },
    commentChangeEventOnBlur: {
      type: Boolean,
      default: true,
    },
    activeFilters: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    labelText() {
      return 'No comments have been posted yet.'
    },

    checkForDeletedComments() {
      return this.userComments.filter(comment => {
        return !comment.isDeleted
      })
    },

    combinedCommentAndStatusList() {
      let typedComments = this.checkForDeletedComments.map(c => {
        return {
          ...c,
          ucType: 'userComment',
          compareTimestamp: new Date(c.createdOn).getTime(),
        }
      })
      let typedStatusUpdates = this.statusUpdates.map(s => {
        return {
          ...s,
          ucType: 'statusUpdate',
          compareTimestamp: new Date(s.updatedOn).getTime(),
        }
      })

      let combinedList = [...typedComments, ...typedStatusUpdates]

      if (this.activeFilters.length > 0) {
        combinedList = combinedList.filter(cl =>
          this.activeFilters.includes(cl.ucType),
        )
      }

      return combinedList.sort(
        (a, b) => b.compareTimestamp - a.compareTimestamp,
      )
    },
  },

  methods: {
    handleDelete(comment) {
      this.$emit('removeComment', comment)
    },
    handlePost(post) {
      this.$emit('updatedComment', post)
    },
  },
}
</script>

<style lang="scss">
.user-comment-list {
  &--container {
    padding: 0 16px;
    overflow-y: scroll;

    .noData {
      color: $gray-600;
    }
  }

  &--list {
    list-style: none;
    padding: 0 !important;
  }

  &--item {
    margin-bottom: 8px;
    padding-top: 6px;

    &:last-child {
      .user-comment--input {
        border-bottom: 0;
      }
    }

    .user-comment--container {
      .noData {
        color: $gray-600;
      }

      .user-comment--input {
        padding-bottom: 8px;
      }

      &.active {
        .user-comment--input {
          padding-bottom: 0;
          border-bottom: none;
        }
      }
    }
  }

  &--border {
    border-bottom: 1px solid $gray-500;
    margin-left: 0px;
  }
}
.comment-enter-active {
  transition: all 0.4s ease;
}
.comment-leave-active {
  transition: all 0.4s ease;
  position: absolute;
  width: 100%;
}
.comment-enter {
  opacity: 0;
  transform: translateY(-10px);
}
.comment-leave-to {
  opacity: 0;
}
.comment-move {
  transition: transform 0.4s ease;
}
</style>
